import { makeStyles, Theme } from '@material-ui/core/styles';
import { SecondaryColors } from '@/utils/constants';

export const usePortalCookieModalContentStyles = makeStyles((muiTheme: Theme) => ({
  root: {
    backgroundColor: 'white',
    width: '500px',
    maxWidth: '100%',
    padding: muiTheme.spacing(4),
  },
  title: {
    textAlign: 'center',
    marginBottom: muiTheme.spacing(2),
    fontWeight: 'bolder',
  },
  content: {
    marginBottom: muiTheme.spacing(3),
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    gap: muiTheme.spacing(2),
    '& .action-button': {
      backgroundColor: SecondaryColors.main,
      color: 'white',
      borderRadius: 0,
      padding: muiTheme.spacing(1, 2),
    },
  },
}));
